import React, { useRef, useState } from "react";
import assets from "../assets/assets";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay, EffectFade } from "swiper/modules";

const Understanding = () => {
  const [swiperInstance, setSwiperInstance] = useState(null);

  // Handle previous slide click
  const handlePrevClick = () => {
    if (swiperInstance) {
      swiperInstance.slidePrev();
    }
  };

  // Handle next slide click
  const handleNextClick = () => {
    if (swiperInstance) {
      swiperInstance.slideNext();
    }
  };

  const {
    demo_it_business_three,
    demo_it_business_four,
    demo_it_business_five,
    demo_it_business_six,
  } = assets();

  const data = [
    {
      title: "Data and analytics",
      shortDescription: "Lorem ipsum simply dummy text of amet consectetur.",
      image: demo_it_business_three,
      btnName: "analytics",
    },
    {
      title: "Data and analytics",
      shortDescription: "Lorem ipsum simply dummy text of amet consectetur.",
      image: demo_it_business_four,
      btnName: "analytics",
    },
    {
      title: "Data and analytics",
      shortDescription: "Lorem ipsum simply dummy text of amet consectetur.",
      image: demo_it_business_five,
      btnName: "analytics",
    },
    {
      title: "Data and analytics",
      shortDescription: "Lorem ipsum simply dummy text of amet consectetur.",
      image: demo_it_business_six,
      btnName: "analytics",
    },
    {
      title: "Data and analytics",
      shortDescription: "Lorem ipsum simply dummy text of amet consectetur.",
      image: demo_it_business_three,
      btnName: "analytics",
    },
  ];

  return (
    <section className="overflow-hidden bg-very-light-gray position-relative">
      <div className="container">
        <div
          className="row align-items-center mb-5 sm-mb-30px text-center text-lg-start"
          data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 300, "easing": "easeOutQuad" }'
        >
          <div className="col-lg-5 md-mb-30px">
            <h1 className="text-dark-gray fw-700 ls-minus-2px mb-0">
              Understanding the business services.
            </h1>
          </div>
          <div className="col-lg-4 offset-xl-1 last-paragraph-no-margin md-mb-30px">
            <p>
              We strive to develop real-world web solutions that are ideal for
              small to large projects with bespoke your custom project
              requirements.
            </p>
          </div>
          <div className="col-xl-2 col-lg-3 d-flex justify-content-center">
            <div
              onClick={handlePrevClick}
              className=" d-flex justify-content-center"
            >
              <div className="slider-one-slide-prev-1 icon-small text-dark-gray swiper-button-prev slider-navigation-style-04 bg-white box-shadow-large">
                <i className="fa-solid fa-arrow-left"></i>
              </div>
            </div>
            <div
              onClick={handleNextClick}
              className=" d-flex justify-content-center"
            >
              <div className="slider-one-slide-next-1 icon-small text-dark-gray swiper-button-next slider-navigation-style-04 bg-white box-shadow-large">
                <i className="fa-solid fa-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          loop={true}
          speed={1000}
          breakpoints={{
            0: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
            1440: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
          }}
          modules={[EffectFade, Autoplay]}
          className="mySwiper"
          onSwiper={setSwiperInstance} // Initialize swiperInstance when the Swiper component is ready
        >
          {data.map((review, index) => (
            <SwiperSlide key={index} className="rounded">
              <div className="services-box-style-03 last-paragraph-no-margin border-radius-6px overflow-hidden">
                <div className="position-relative">
                  <a href="#">
                    <img alt="" src={review.image} />
                    <noscript>
                      <img src={review.image} alt="" />
                    </noscript>
                  </a>
                  <a
                    href="#"
                    className="btn btn-very-small btn-rounded btn-dark-gray text-white btn-box-shadow ps-15px pe-15px pt-5px pb-5px lh-16 position-absolute right-30px top-30px text-uppercase"
                  >
                    {review.btnName}
                  </a>
                </div>
                <div className="bg-white">
                  <div className="px-3 pt-30px pb-30px text-center">
                    <a
                      href="#"
                      className="d-inline-block fs-18 fw-700 text-dark-gray mb-5px"
                    >
                      {review.title}
                    </a>
                    <p>{review.shortDescription}</p>
                  </div>
                  <div className="d-flex justify-content-center border-top border-color-extra-medium-gray pt-20px pb-20px ps-50px pe-50px position-relative text-center">
                    <a
                      href="#"
                      className="btn btn-link btn-hover-animation-switch btn-medium fw-700 text-dark-gray text-uppercase"
                    >
                      <span>
                        <span className="btn-text text-nowrap">Explore services</span>
                        <span className="btn-icon">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                        <span className="btn-icon">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Understanding;
